import { UseFetchOptions, UseFetchReturn } from '@vueuse/core';
import { Ref, ref } from 'vue';

import { concatenatedTemplatesResponseMapper, splittedTemplatesResponseMapper } from '@/api/ClientApiMapper';
import { useEditorApiFetch } from '@/api/composables/useEditorApiFetch';
import { BasicShapeApi, MappedApiResponse } from '@/Types/apiClient';

export const getConcatenatedBasicShapes = (
	url: Ref<string>,
	options: UseFetchOptions = {}
): UseFetchReturn<MappedApiResponse<BasicShapeApi[]>> => {
	const concatenatedData = ref<BasicShapeApi[]>([]);

	return useEditorApiFetch(url, {
		...options,
		afterFetch: (ctx) => concatenatedTemplatesResponseMapper(ctx, concatenatedData),
	})
		.get()
		.json();
};

export const getSplittedBasicShapes = (
	url: Ref<string>,
	options: UseFetchOptions = {}
): UseFetchReturn<MappedApiResponse<BasicShapeApi[]>> => {
	return useEditorApiFetch(url, {
		...options,
		afterFetch: (ctx) => splittedTemplatesResponseMapper(ctx),
	})
		.get()
		.json();
};
